
    import { Component, Vue } from 'vue-facing-decorator';
    import { Action, Getter } from '@/plugins/vuex-decorators';

    const namespace = 'main';

    @Component
    export default class TopLeftMenu extends Vue {
        private namespace = 'main';

        @Getter('getModel', { namespace }) getModel: any;
        @Getter('getLocation', { namespace }) getLocation: any;
        @Action('fetchProcessingLog', { namespace }) fetchProcessingLog: any;
        @Getter('getScenario', { namespace }) getScenario: any;
        @Getter('getArea', { namespace }) getArea: any;
        @Getter('getVersion') getVersion: any;
        @Getter('getUser') getUser!: any;

        private get getBuildDate(): any {
            return process.env.VUE_APP_BUILD_DATE;
        }

        get isPermissionManager() { return this.getUser?.roles?.includes('PermissionManager'); }
        get isGlobalCalculator() { return this.getUser?.roles?.includes('GlobalCalculator'); }
        get isLogViewer() { return this.getUser?.roles?.includes('LogViewer'); }

        private router: any;
        private mounted() {
            this.router = this.$router;
        }

        // Restore the model/scenario/location selection (stored in the query params)
        // that the user had before entering an admin page.
        private goHome() {
            let query: any = {};
            try {
                const saved = sessionStorage.getItem('lastHomeQuery');
                if (saved) query = JSON.parse(saved);
            } catch {
                query = {};
            }
            this.$router.push({ name: 'Default', query });
        }

    }
